import { observer } from "mobx-react-lite";
import React, { FC, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import { useClickAway } from "ahooks";
import config from "@/config";
interface DialogProps {
  visible: boolean;
  children?: React.ReactNode;
  onClose: () => void;
}
const Dialog: FC<DialogProps> = (props) => {
  const { children, onClose, visible } = props;
  const dialogContentRef = useRef<HTMLDivElement>(null);
  useClickAway((e) => {
    onClose?.();
  }, dialogContentRef);
  useEffect(() => {
    //监听esc键盘事件
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose && onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
  if (!visible) return null;
  return (
    <div className={styles.dialogWrapper}>
      <div className={styles.dialogContent} ref={dialogContentRef}>
        <img
          src={`${config.buildCdnBaseUrl}assets/creator/white-close.png`}
          alt=""
          className={styles.close}
          onClick={onClose}
        />
        {children && children}
      </div>
    </div>
  );
};
export default observer(Dialog);
